import type { Thing, WithContext } from "schema-dts"

type Props<T extends Thing> = {
  data: WithContext<T>
}

// https://nextjs.org/docs/app/guides/json-ld
export const JsonLD = <T extends Thing>({ data }: Props<T>) => {
  return (
    <script
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data is safe
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, "\\u003c"),
      }}
      type="application/ld+json"
    />
  )
}
